module.exports = __webpack_public_path__ + "img/bitcoin.fa1775ae.svg";